import { Email, SystemRecord } from '../types/email'

export const mockSystemRecords: SystemRecord[] = [
  {
    id: '1',
    type: 'company',
    referenceNumber: 'COMP-12345',
    name: 'Acme Corporation',
    status: 'Active',
  },
  {
    id: '2',
    type: 'company',
    referenceNumber: 'COMP-67890',
    name: 'TechStart Inc',
    status: 'Active',
  },
  {
    id: '3',
    type: 'case',
    referenceNumber: 'CASE-98765',
    name: 'Contract Dispute - Acme',
    status: 'Open',
  },
  {
    id: '4',
    type: 'case',
    referenceNumber: 'CASE-11111',
    name: 'Service Agreement Review',
    status: 'Closed',
  },
  {
    id: '5',
    type: 'enquiry',
    referenceNumber: 'ENQ-54321',
    name: 'Product Demo Request',
    status: 'Pending',
  },
  {
    id: '6',
    type: 'transaction',
    referenceNumber: 'TXN-11223',
    name: 'Invoice Payment',
    status: 'Completed',
    metadata: { amount: '$15,000' },
  },
  {
    id: '7',
    type: 'transaction',
    referenceNumber: 'TXN-99887',
    name: 'Refund Request',
    status: 'Processing',
    metadata: { amount: '$2,500' },
  },
]

export const mockEmails: Email[] = [
  {
    id: 'e1',
    from: 'john.smith@acme.com',
    subject: 'Re: Contract Review - CASE-98765',
    body: "Hi team,\n\nI wanted to follow up on CASE-98765 regarding the contract dispute. We've reviewed the terms and would like to proceed with the amendments discussed.\n\nThe related transaction TXN-11223 has been processed successfully.\n\nBest regards,\nJohn Smith",
    receivedAt: new Date(Date.now() - 1000 * 60 * 15),
    status: 'auto-linked',
    references: [
      {
        id: 'r1',
        number: 'CASE-98765',
        type: 'case',
        found: true,
        recordId: '3',
      },
      {
        id: 'r2',
        number: 'TXN-11223',
        type: 'transaction',
        found: true,
        recordId: '6',
      },
    ],
    linkedRecords: [
      {
        id: '3',
        type: 'case',
        name: 'Contract Dispute - Acme',
        referenceNumber: 'CASE-98765',
        metadata: { status: 'Open' },
      },
      {
        id: '6',
        type: 'transaction',
        name: 'Invoice Payment',
        referenceNumber: 'TXN-11223',
        metadata: { status: 'Completed', amount: '$15,000' },
      },
    ],
    processedAt: new Date(Date.now() - 1000 * 60 * 14),
  },
  {
    id: 'e2',
    from: 'sarah.jones@techstart.com',
    subject: 'Product Demo Follow-up',
    body: 'Hello,\n\nThank you for the demo yesterday. I have a few questions about the enterprise features.\n\nCould we schedule a call next week?\n\nThanks,\nSarah',
    receivedAt: new Date(Date.now() - 1000 * 60 * 45),
    status: 'needs-review',
    references: [],
    linkedRecords: [],
    processedAt: new Date(Date.now() - 1000 * 60 * 44),
  },
  {
    id: 'e3',
    from: 'billing@vendor.com',
    subject: 'Invoice #INV-2024-001 - Reference: COMP-12345',
    body: 'Dear Customer,\n\nPlease find attached invoice INV-2024-001 for services rendered.\n\nCompany Reference: COMP-12345\nAmount Due: $8,500\nDue Date: March 15, 2024\n\nThank you for your business.',
    receivedAt: new Date(Date.now() - 1000 * 60 * 120),
    status: 'auto-linked',
    references: [
      {
        id: 'r3',
        number: 'COMP-12345',
        type: 'company',
        found: true,
        recordId: '1',
      },
    ],
    linkedRecords: [
      {
        id: '1',
        type: 'company',
        name: 'Acme Corporation',
        referenceNumber: 'COMP-12345',
        metadata: { status: 'Active' },
      },
    ],
    processedAt: new Date(Date.now() - 1000 * 60 * 119),
  },
  {
    id: 'e4',
    from: 'support@customer.com',
    subject: 'Urgent: Issue with Order',
    body: "We're experiencing issues with our recent order. The reference number mentioned was CASE-99999 but we can't find it in our system.\n\nPlease advise urgently.\n\nRegards,\nSupport Team",
    receivedAt: new Date(Date.now() - 1000 * 60 * 30),
    status: 'needs-review',
    references: [
      { id: 'r4', number: 'CASE-99999', type: 'case', found: false },
    ],
    linkedRecords: [],
    processedAt: new Date(Date.now() - 1000 * 60 * 29),
  },
  {
    id: 'e5',
    from: 'finance@acme.com',
    subject: 'Payment Confirmation',
    body: 'Payment has been processed for transaction TXN-99887.\n\nPlease confirm receipt.\n\nFinance Department',
    receivedAt: new Date(Date.now() - 1000 * 60 * 5),
    status: 'processing',
    references: [],
    linkedRecords: [],
  },
]
